<template>
    <div class='text_box'>
        <div class="title">隐私政策</div>
        <div>
            <h2>修改日期：2021 年 06 月 20 日</h2>
        </div>
        <div>
            <h2>生效日期：2021 年 06 月 20 日</h2>
        </div>
        <div>成都市艺苑网络科技有限公司（以下简称“平台”或“我们”）为您提供在线视频直播、视频交友（以下简称“产品”））及其他与产品相关的服务。</div>
        <div>当您与我们就取得产品或服务进行联系时，将可能被要求提供部分个人信息。</div>
        <div>您的信任对我们非常重要，我们深知个人信息对您的重要性，我们将按法律法规要求，采取相应安全保护措施，尽力保护您的个人信息安全可控。鉴于此，我们制定本《隐私权政策》（下称“本政策/本隐私权政策”）以阐述我们如何收集、使用及储存您的个人信息，我们将如何保护您的个人信息安全。</div>
        <div><strong>需要特别说明的是，本政策不适用于其他第三方向您提供的服务，为确保流畅的产品体验，您可能会收到来自第三方提供的内容或网络链接。请您谨慎选择是否访问第三方提供的链接、内容、产品和服务。在向第三方提交个人信息之前，请认真阅读这些第三方的隐私政策。</strong></div>
        <div><strong>在使用我们各项产品或服务前，请您务必仔细阅读并透彻理解本政策，特别是以粗体标识的条款，您应重点阅读，在确认充分理解并同意后再开始使用。 如对本政策内容有任何疑问、意见或建议，您可通过访问平台在线客服系统或拨打我们的客服电话等方式与我们联系。</strong></div>
        <div><strong>如果您不同意本隐私政策，您可以放弃使用我们的产品和/或服务。一旦您开始使用平台提供的各项产品或服务，即表示您已充分理解并同意本政策。</strong></div>
        <div>
            <h2>一、定义</h2>
            <ul>
                <li><strong>儿童：</strong> 指不满十四周岁的未成年人。</li>
                <li><strong>个人信息： </strong>指以电子或者其他方式记录的能够单独或者与其他信息结合识别特定自然人身份或者反映特定自然人活动情况的各种信息。</li>
                <li><strong>个人敏感信息：</strong>指包括身份证件号码、个人生物识别信息、银行账号、财产信息、行踪轨迹、交易信息、儿童信息等的个人私密信息（我们将在本隐私权政策中对具体个人敏感信息以<strong>粗体</strong>进行显著标识）。</li>
                <li><strong>个人信息删除：</strong>指在实现日常业务功能所涉及的系统中去除个人信息的行为，使其保持不可被检索、访问的状态。</li>
            </ul>
        </div>
        <div>
            <h2>二、我们如何收集和使用您的个人信息</h2>
            <ul>
                <li>
                    <h3>（一）收集和使用个人信息的目的</h3>
                    <ul>
                        <li>我们仅会出于本政策所述的以下目的，收集和使用您的个人信息：
                            <ul>
                                <li>（1）保障产品服务能够正常运行；</li>
                                <li>（2）保障产品服务、用户使用的安全；</li>
                                <li>（3）实现个性化产品功能或服务需求；</li>
                                <li>（4）管理软件，例如软件认证、软件升级等；</li>
                                <li>（5）遵循法律法规及国家标准的规定。</li>
                            </ul>
                        </li>
                        <li>当我们要将个人信息用于本政策未载明的其它用途时，会事先征求您的同意。当我们要将基于特定目的收集而来的信息用于其他目的时，会事先征求您的同意。</li>
                    </ul>
                </li>
                <li>
                    <h3>（二）我们直接收集和使用的个人信息</h3>
                    <ul>
                        <li>
                            <strong>1、保障产品的正常基础运行</strong>
                            <ul>
                                <li>当您使用我们的产品时，为了保障产品基础功能及服务能过正常运行，您需要同意我们收集您的如下信息：
                                    <ul>
                                        <li><strong>设备信息：</strong>我们会根据您在软件安装及/或使用中的具体操作，接收并记录您所使用的设备相关信息（包括设备型号、操作系统版本、设备设置、唯一设备标识符、设备环境等软硬件特征信息）、设备所在位置相关信息（包括您<strong>授权的GPS位置</strong>以及WLAN接入点、蓝牙和基站等传感器信息）。</li>
                                        <li><strong>服务日志信息：</strong>当您使用我们提供的产品或服务时，我们会自动收集您对我们服务的详细使用情况，作为服务日志保存，包括<strong>浏览、点击查看、</strong>搜索查询、收藏、关注分享信息、发布信息，以及<strong>IP地址、</strong>浏览器类型、电信运营商、使用语言、访问日期和时间等。</li>
                                        <li><strong>请注意，单独的设备信息、服务日志信息是无法识别特定自然人身份的信息。</strong> 如果我们将这类非个人信息与其他信息结合用于识别特定自然人身份，或者将其与个人信息结合使用，则在结合使用期间，这类非个人信息将被视为个人信息，除取得您授权或法律法规另有规定外，我们会将这类信息做匿名化、去标识化处理。</li>
                                        <li><strong>为向您提供更便捷、更符合您个性化需求的信息展示、搜索及推送服务，我们会根据您的设备信息和服务日志信息，提取您的偏好特征，并基于特征标签产出间接人群画像，用于展示、推送信息。</strong></li>
                                        <li><strong>我们可能会向您推荐更感兴趣的信息，为实现这一功能，我们可能会使用您的设备所在位置相关信息。其中，位置权限涉及个人敏感信息，若您拒绝提供，我们将不会根据您的位置信息向您进行资讯推荐，且不会影响其他不需要位置权限的服务正常使用。我们会基于IP地址对应的城市向您展示、推荐您所在地区的本地相关信息。</strong></li>
                                        <li>我们收集、使用的上述信息均进行了去标识化处理，数据分析仅对应特定的、无法直接关联您身份的编码，不会与您的真实身份相关联。</li>
                                    </ul>
                                </li>
                            </ul>
                        </li>
                        <li>
                            <strong>2、为您提供注册、认证服务</strong>
                            <ul>
                                <li>（1）当您通过移动手机号码注册产品账号时，为完成注册，<strong>您需提供完整的、可接收短信或电话的手机号码，我们将通过发送短信验证码或语音验证码的方式确认您的身份是否有效。</strong>通过验证且您阅读并同意本政策及用户协议后，将完成账号注册。</li>
                                <li>（2）当您通过第三方账号<strong>（例如微信、QQ、微博等）登录产品，您需要授权我们获取您登录所使用的第三方账号的公开信息（例如头像、昵称、性别等），并将该账号与您的产品账号进行绑定。</strong>如果您不同意授权或拒绝我们获取上述信息，您将无法通过第三方账号登录产品，但不影响您正常使用产品的其他功能。</li>
                                <li>（3）完成产品账号注册后，您可以自行决定是否需要完善您的头像、昵称、密码、性别、星座、家乡、行业、经常出没的地方、个人简介、个人喜好等账号信息。如果您完善以上额外信息，将有助于我们为您提供更好的服务和体验，但如果您不提供上述信息，将不会影响使用产品的基本功能。</li>
                                <li>（4）如果您选择完善您的头像信息而使用我们的上传头像功能时，我们将会请求您授权写入外置存储器功能和读取外置存储器功能。在您选择使用拍照的图片作为头像时，需要将您拍摄的照片暂时储存到外置储存器上。在您选择图片上传时，需要对您的手机相册权限进行读取，并按照您的选择上传头像。</li>
                                <li>（5）我们将获取您的手机摄像头权限用以帮助您进行扫码登陆、支付、拍摄照片或视频上传、分享，以及特定场景下经您授权的人脸识别等功能。当您使用该附加功能进行人脸识别时我们会收集您的面部特征，且严格在经您授权同意的范围内使用。</li>
                            </ul>
                        </li>
                        <li>
                            <strong>3、实现直播、音视频、语音及图文发布等功能或服务</strong>
                            <ul>
                                <li>您主动进行直播、发布音视频、评论信息、图文等时，我们将收集音视频、图文等相应信息，并展示您的昵称、头像、发布信息内容等。
                                    <ul>
                                        <li>（1）您发布直播或音视频时，我们会请求您授权相机、照片、麦克风等权限。如果您不同意或拒绝授权提供，将无法使用此功能，但不影响您正常使用产品的其他功能。</li>
                                        <li>（2）当您使用语音连麦聊天及录音时，我们会请求您授权录音权限。在此过程中，我们会收集您的录音内容。请您知晓，即使您已同意开启麦克风权限，我们也仅会在您主动点击客户端内麦克风图标时通过麦克风获取语音信息。如果您不同意或拒绝授权提供，将无法使用此功能，但不影响您正常使用产品的其他功能。</li>
                                    </ul>
                                </li>
                                <li><strong>您发布音视频、图文等信息并选择显示地理位置或使用我们基于位置提供的“同城”时，我们会请求访问您的精准定位信息（属于个人敏感信息）并收集与上述功能相关的定位信息。在您使用“附近”功能时，我们会请求访问您的粗略位置信息（属于个人敏感信息）并收集与上述功能相关的定位信息。我们收集定位信息的技术包括IP地址、GPS、WLAN等传感器技术。</strong>您如果不同意或拒绝授权提供，将无法使用此功能，但不影响您正常使用产品的其他功能。</li>
                                <li>您使用发布直播、发布直播评论或其他需要进行身份认证的功能或服务时，根据中华人民共和国相关法律法规规定，<strong>您需要提供真实身份信息（包括但不限于真实姓名、手机号码、身份证号等个人敏感信息），用于完成实名认证。</strong>如果您不提供上述信息或信息不真实，将无法使用此功能，但不影响您正常使用产品的其他功能。</li>
                            </ul>
                        </li>
                        <li>
                            <strong>4、实现互动交流功能或服务</strong>
                            <ul>
                                <li>（1）您主动关注您感兴趣的用户账号并与其他账号进行交流互动、进行评论或分享内容时，我们会收集您关注的账号，并向您展示您关注账号发布内容。</li>
                                <li>（2）您主动点赞、评论或分享您感兴趣的音视频、图文等信息时，我们会收集您点赞、评论或分享的内容，并向您点赞或评论的用户进行展示或推送通知。</li>
                                <li>（3）您主动使用虚拟财产向其他用户进行打赏时，我们将收集您的头像、昵称及打赏的数据，并向其他用户进行展示。</li>
                            </ul>
                        </li>
                        <li>
                            <strong>5、实现搜索服务</strong>
                            <ul>
                                <li>您使用产品的搜索服务时，我们会收集您的搜索关键字信息、日志记录等。为了提供高效的搜索服务，部分前述信息会暂时存储在您的设备之中，并可向您展示搜索结果内容、搜索历史记录。您可以自主选择是否清除上述搜索历史记录。</li>
                            </ul>
                        </li>
                        <li>
                            <strong>6、保障产品、服务及用户使用安全</strong>
                            <ul>
                                <li>为帮助我们更好地了解产品的运行情况，以便确保运行、改善优化以及提供产品的安全，我们可能记录网络日志信息，以及使用软件及相关服务的频率、崩溃数据、总体安装、使用情况、性能数据等信息。</li>
                            </ul>
                        </li>
                        <li>
                            <strong>7、身份验证</strong>
                            <ul>
                                <li>
                                    <strong>根据法律法规及监管要求，当您使用产品的支付、提现等类似功能时，需要您提供有效的身份证件信息、支付宝账号、联系方式、地址等个人信息，以完成身份基本信息多重交叉验证。</strong>如果您不提供前述信息，将无法使用此功能，但不影响您正常使用产品的其他功能。
                                </li>
                                <li>（1）其他用户因使用我们的产品而被我们收集的信息，例如其他用户发布的信息中可能含有您的部分个人信息（如：在评论、留言、直播、发布图文、音视频中涉及到与您相关的信息）。</li>
                                <li><strong>（2）在您使用产品提供的身份认证功能时，我们会根据相关法律法规规定和/或该身份认证功能（如芝麻信用）所必需，</strong>我们将采用行业内通行的方式及尽最大的商业努力来保护您个人敏感信息的安全。如果您不提供这些信息，您将可能无法获得相关服务，但不影响您正常使用其他功能。</li>
                            </ul>
                        </li>
                        <li>
                            <strong>8、支付与提现功能</strong>
                            <ul>
                                <li>当您使用产品的支付、提现等类似功能时，可能需要收集您的姓名、银行卡类型及卡号、有效期及手机号码。银行卡号、有效期及手机号码是个人敏感信息，这些信息是支付、提现和主播认证功能所必需的信息，拒绝提供将导致您无法使用该功能，但不影响其他功能的正常使用。</li>
                            </ul>
                        </li>
                        <li>
                            <strong>9、其他</strong>
                            <ul>
                                <li>（1）若您提供的信息中含有其他用户的个人信息，在向我们提供这些个人信息之前，您需确保您已经取得合法的授权。</li>
                                <li>（2）若我们将信息用于本政策未载明的其他用途，或者将基于特定目的收集而来的信息用于其他目的，或者我们主动从第三方处获取您的个人信息，均会事先获得您的同意。</li>
                                <li>（3）我们可能随着业务的发展，会对产品有所调整。当新功能或服务与注册、直播、音视频推荐、广告推送、发布图文、账号推荐、互动交流、搜索、查询、认证、虚拟财产等场景相关时，收集与使用的个人信息属于与原目的具有直接关联。在与原目的无直接关联的场景下，我们收集、使用您的个人信息，会再次征得您的同意。</li>
                                <li>（4）您需要注意，本政策仅说明收集信息的情形，我们实际从第三方间接获取的个人信息范围以页面展示为准。本政策不能作为第三方服务的隐私政策条款，我们强烈建议您在使用第三方服务前阅读并理解第三方服务有关的服务协议及隐私政策的具体内容，了解第三方服务向您收集使用个人信息的规则，所能提供的保护和您能享有的个人信息权利。</li>
                            </ul>
                        </li>
                        <li>
                            <strong>10、征得授权同意的例外</strong>
                            <ul>
                                <li>您充分知晓，根据相关法律法规规定，以下情形中，我们收集、使用个人信息无需征得您的授权同意：
                                    <ul>
                                        <li>（1）与国家安全、国防安全有关的；</li>
                                        <li>（2）与公共安全、公共卫生、重大公共利益有关的；</li>
                                        <li>（3）与犯罪侦查、起诉、审判和判决执行等有关的；</li>
                                        <li>（4）出于维护个人信息主体或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；</li>
                                        <li>（5）所收集的个人信息是个人信息主体自行向社会公众公开的；</li>
                                        <li>（6）从合法公开披露的信息中收集的您的个人信息的，如合法的新闻报道、政府信息公开等渠道；</li>
                                        <li>（7）根据您的要求签订合同所必需的；</li>
                                        <li>（8）用于维护所提供的产品与/或服务的安全稳定运行所必需的，例如发现、处置产品与/或服务的故障；</li>
                                        <li>（9）为合法的新闻报道所必需的；</li>
                                        <li>（10）学术研究机构基于公共利益开展统计或学术研究所必要，且对外提供学术研究或描述的结果时，对结果中所包含的个人信息进行去标识化处理的；</li>
                                        <li>（11）法律法规规定的其他情形。</li>
                                    </ul>
                                </li>
                            </ul>
                        </li>
                    </ul>
                </li>
            </ul>
        </div>
        <div>
            <h2>三、我们如何使用 Cookie、同类技术和SDK技术</h2>
            <ul>
                <li><h3>（一）Cookie</h3>
                    <ul>
                        <li>为使您获得更轻松的访问体验，您访问斗平台网站或使用平台提供的服务时，我们可能会通过小型数据文件识别您的身份，这么做是帮您省去重复输入注册信息的步骤，或者帮助判断您的帐号安全。这些数据文件可能是Cookie，Flash Cookie，或您的浏览器或关联应用程序提供的其他本地存储（统称“Cookie”）。 请您理解，平台的某些服务只能通过使用“Cookie”才可得到实现。如果您的浏览器或浏览器附加服务允许，您可以修改对Cookie的接受程度或者拒绝平台的Cookie，但这一举动在某些情况下可能会影响您安全访问平台相关网站和使用平台提供的服务。</li>
                    </ul>
                </li>
                <li><h3>（二）与Cookie同类技术</h3>
                    <ul>
                        <li>为保证产品相关功能的实现与应用安全稳定的运行，我们可能会接入由第三方服务提供商提供的软件开发包（SDK）实现相关目的。我们会对合作获取信息的软件工具开发包（SDK）进行严格的安全监测，以保证数据安全。</li>
                    </ul>
                    <table style="margin: 10px auto;width:100%" border="1" cellspacing="0" border-color="#29282C">
                        <tr style="font-weight: bold; color: #000; font-size: 14px; text-align: center; line-height: 20px; height: 20px">
                            <td style="width: 22%">服务类型</td>
                            <td style="width: 30%">SDK名称</td>
                            <td style="width: 48%">服务内容</td>
                        </tr>
                        <tr style="color: #302E3E; font-size: 12px; text-align: center; line-height: 20px; height: 20px">
                            <td>定位服务</td>
                            <td>百度地图</td>
                            <td>提供用户位置服务，帮助用户发布信息时定位位置</td>
                        </tr>
                        <tr style="color: #302E3E; font-size: 12px; text-align: center; line-height: 20px; height: 20px">
                            <td>认证服务</td>
                            <td>阿里芝麻认证SDK</td>
                            <td>提供实名认证功能</td>
                        </tr>
                        <tr style="color: #302E3E; font-size: 12px; text-align: center; line-height: 20px; height: 20px">
                            <td>社交服务</td>
                            <td>QQ SDK</td>
                            <td>支持QQ登录、帮助用户分享内容至第三方应用</td>
                        </tr>
                        <tr style="color: #302E3E; font-size: 12px; text-align: center; line-height: 20px; height: 20px">
                            <td>社交服务</td>
                            <td>微博SDK</td>
                            <td>支持微博登录、帮助用户分享内容至第三方应用</td>
                        </tr>
                        <tr style="color: #302E3E; font-size: 12px; text-align: center; line-height: 20px; height: 20px">
                            <td>社交服务</td>
                            <td>微信SDK</td>
                            <td>支持微信分享、微信支付、帮助用户分享内容至第三方应用</td>
                        </tr>
                        <tr style="color: #302E3E; font-size: 12px; text-align: center; line-height: 20px; height: 20px">
                            <td>数据分析服务</td>
                            <td>数美</td>
                            <td>反作弊</td>
                        </tr>
                        <tr style="color: #302E3E; font-size: 12px; text-align: center; line-height: 20px; height: 20px">
                            <td>数据分析服务</td>
                            <td>友盟统计</td>
                            <td>推广统计和效果分析</td>
                        </tr>
                        <tr style="color: #302E3E; font-size: 12px; text-align: center; line-height: 20px; height: 20px">
                            <td>数据分析服务</td>
                            <td>数字联盟</td>
                            <td>提供终端有效性识别的移动安全技术术服务</td>
                        </tr>
                        <tr style="color: #302E3E; font-size: 12px; text-align: center; line-height: 20px; height: 20px">
                            <td>数据分析服务</td>
                            <td>Firebase</td>
                            <td>推广统计和效果分析</td>
                        </tr>
                        <tr style="color: #302E3E; font-size: 12px; text-align: center; line-height: 20px; height: 20px">
                            <td>数据分析服务</td>
                            <td>Appsflyer</td>
                            <td>推广统计和效果分析</td>
                        </tr>
                        <tr style="color: #302E3E; font-size: 12px; text-align: center; line-height: 20px; height: 20px">
                            <td>问题追踪服务</td>
                            <td>Bugly</td>
                            <td>提供App稳定性监控，崩溃上报，帮助开发者快速发现并解决崩溃;	嵌入该SDK，SDK将收集传输个人信息</td>
                        </tr>
                        <tr style="color: #302E3E; font-size: 12px; text-align: center; line-height: 20px; height: 20px">
                            <td>效果服务</td>
                            <td>商汤SDK</td>
                            <td>人脸识别和美颜</td>
                        </tr>
                        <tr style="color: #302E3E; font-size: 12px; text-align: center; line-height: 20px; height: 20px">
                            <td>效果服务</td>
                            <td>即构</td>
                            <td>多路音视频服务</td>
                        </tr>
                        <tr style="color: #302E3E; font-size: 12px; text-align: center; line-height: 20px; height: 20px">
                            <td>验证服务</td>
                            <td>极验</td>
                            <td>提供一键手机号验证登录服务</td>
                        </tr>
                        <tr style="color: #302E3E; font-size: 12px; text-align: center; line-height: 20px; height: 20px">
                            <td>语音识别服务</td>
                            <td>讯飞</td>
                            <td>为用户提供文字转语音功能服务</td>
                        </tr>
                        <tr style="color: #302E3E; font-size: 12px; text-align: center; line-height: 20px; height: 20px">
                            <td>音频视频服务</td>
                            <td>声网SDK</td>
                            <td>为直播提供音视频推拉流服务</td>
                        </tr>
                        <tr style="color: #302E3E; font-size: 12px; text-align: center; line-height: 20px; height: 20px">
                            <td>音频视频服务</td>
                            <td>金山云推流sdk</td>
                            <td>为直播提供音视频推拉流服务</td>
                        </tr>
                        <tr style="color: #302E3E; font-size: 12px; text-align: center; line-height: 20px; height: 20px">
                            <td>音频视频服务</td>
                            <td>金山云播放sdk</td>
                            <td>为直播提供音视频推拉流服务</td>
                        </tr>
                    </table>
                </li>
            </ul>
        </div>
        <div>
            <h2>四、我们如何保存您的个人信息</h2>
            <ul>
                <li>按照法律法规的规定，我们将在境内运营过程中收集和产生的<strong>个人信息存储在中华人民共和国境内，</strong>且不会将该等信息向境外传输。如平台因业务发展需要，需向境外进行传输的，将明确告知并征得您的同意。</li>
                <li>我们会采取合理可行的措施避免收集无关的个人信息。我们只会在达成本协议所述目的所需的最短期限内保留您的个人信息，除非您同意延长保留期或受到法律的允许。<strong>超出保存期限后，我们将删除您的个人信息或采取技术措施进行脱敏化处理，但法律法规另有规定的除外。</strong></li>
            </ul>
        </div>
        <div>
            <h2>五、我们如何保护您的个人信息</h2>
            <ul>
                <li>（一）我们采取符合业界通用解决方案、合理可行的安全防护措施保护您提供的个人信息安全，防止个人信息遭到未经授权访问、公开披露、使用、修改、损坏或丢失。我们会使用加密技术提高个人信息的安全性；我们会使用受信赖的保护机制防止个人信息遭到恶意攻击；我们会部署访问控制机制，尽力确保只有授权人员才可访问个人信息；我们会部署代码安全扫描以及访问过滤服务器，对所有代码及访问做过滤处理；以及我们会举办安全和隐私保护培训课程，加强员工对于保护个人信息重要性的认识。</li>
                <li>（二）我们有行业先进的以数据为核心，围绕数据生命周期进行的数据安全管理体系，从组织建设、制度设计、人员管理、产品技术等方面多维度提升整个系统的安全性。</li>
                <li>（三）我们会采取合理可行的措施，尽力避免收集无关的个人信息。我们只会在达成本政策所述目的所需的期限内保留您的个人信息，除非需要延长保留期或受到法律的允许。</li>
                <li>（四）互联网并非绝对安全的环境，我们强烈建议您不要使用非经我们推荐的方式发送个人信息。您可以通过我们的服务与其他用户建立联系和相互分享。当您通过我们的服务创建交流、交易或分享时，您可以自主选择沟通、交易或分享的对象，作为能够看到您的交易内容、联络方式、交流信息或分享内容等相关信息的第三方。</li>
                <li>如您发现自己的个人信息尤其是您的账户或密码发生泄露，请您立即联络客服，以便我们根据您的申请采取相应措施。同时，我们还将按照监管部门要求，上报个人信息安全事件的处置情况。</li>
            </ul>
        </div>
        <div>
            <h2>六、我们如何共享、转让、公开披露您的个人信息</h2>
            <ul>
                <li>
                    <h3>（一）共享</h3>
                    <ul>
                        <li>我们不会与平台服务提供者以外的公司、组织和个人共享您的个人信息，但以下情况除外：
                            <ul>
                                <li>1、在法定情形下的共享： 我们可能会根据法律法规规定、诉讼、争议解决需要，或按行政、司法机关依法提出的要求，对外共享您的个人信息。</li>
                                <li>2、在获取明确同意的情况下共享： 获得您的明确同意后，我们会与其他方共享您的个人信息。</li>
                                <li>3、与授权合作伙伴共享：我们可能委托授权合作伙伴为您提供某些服务或代表我们履行职能， 我们仅会出于本隐私权政策声明的合法、正当、必要、特定、明确的目的共享您的信息，授权合作伙伴只能接触到其履行职责所需信息，且不得将此信息用于其他任何目的。</li>
                            </ul>
                        </li>
                        <li>
                            目前，我们的授权合作伙伴包括以下类型：
                            <ul>
                                <li>（1） 内容分析服务类的授权合作伙伴。产品的内容可能由我们的合作方，或者我们与软件服务提供商、智能设备提供商、系统服务提供商（以下或称“服务提供方”）联合向您提供。除非得到您的许可，否则我们不会将您的个人身份信息与提供内容、分析服务的合作伙伴共享。 我们会委托这些合作伙伴处理与内容覆盖面和有效性相关的信息，但不会提供您的个人身份信息，我们会将去标识化后的个人信息与这些服务提供方等进行共享，基于综合统计并通过算法做特征与偏好分析，形成间接人群画像，而不会识别到您个人。 这类合作伙伴可能将上述信息与他们合法获取的其他数据相结合，以执行我们委托的内容服务或决策建议。</li>
                                <li>（2） 供应商、服务提供商和其他合作伙伴。 我们将信息发送给支持我们业务的供应商、服务提供商和其他合作伙伴，这些支持包括受我们委托提供的技术基础设施服务、分析我们服务的使用方式、衡量广告和服务的有效性、提供客户服务、支付便利或进行学术研究和调查。</li>
                            </ul>
                        </li>
                        <li>
                            我们会对授权合作伙伴获取有关信息的应用程序接口（API）、软件工具开发包（SDK）进行严格的安全检测，并与授权合作伙伴约定严格的数据保护措施，令其按照我们的委托目的、服务说明、本隐私权政策以及其他任何相关的保密和安全措施来处理个人信息。
                        </li>
                    </ul>
                </li>
                <li>
                    <h3>（二）转让</h3>
                    <ul>
                        <li>
                            我们不会将您的个人信息转让给任何公司、组织和个人，但以下情况除外：
                            <ul>
                                <li>（1）在获取明确同意的情况下转让：获得您的明确同意后，我们会向其他方转让您的个人信息；</li>
                                <li>（2）在本产品服务提供者发生合并、收购或破产清算情形，或其他涉及合并、收购或破产清算情形时，如涉及到个人信息转让，我们会要求新的持有您个人信息的公司、组织继续受本政策的约束，否则我们将要求该公司、组织和个人重新向您征求授权同意。</li>
                            </ul>
                        </li>
                    </ul>
                </li>
                <li>
                    <h3>（三）公开披露</h3>
                    <ul>
                        <li>
                            我们仅会在以下情况下，公开披露您的个人信息：
                            <ul>
                                <li>（1）获得您明确同意或基于您的主动选择，我们可能会公开披露您的个人信息；</li>
                                <li>（2）如果我们确定您出现违反法律法规或严重违反本产品相关协议规则的情况，或为保护本产品及其关联公司用户或公众的人身财产安全免遭侵害，我们可能依据法律法规或本产品相关协议规则征得您同意的情况下披露关于您的个人信息，包括相关违规行为以及本产品已对您采取的措施。</li>
                            </ul>
                        </li>
                    </ul>
                </li>
                <li>
                    <h3>（四）共享、转让、公开披露个人信息时事先征得授权同意的例外</h3>
                    <ul>
                        <li>
                            以下情形中，共享、转让、公开披露您的个人信息无需事先征得您的授权同意：
                            <ul>
                                <li>1、与国家安全、国防安全有关的；</li>
                                <li>2、与公共安全、公共卫生、重大公共利益有关的；</li>
                                <li>3、与犯罪侦查、起诉、审判和判决执行等有关的；</li>
                                <li>4、出于维护您或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；</li>
                                <li>5、您自行向社会公众公开的个人信息；</li>
                                <li>6、从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道。</li>
                            </ul>
                        </li>
                        <li>
                            根据法律规定，共享、转让经去标识化处理的个人信息，且确保数据接收方无法复原并重新识别个人信息主体的，不属于个人信息的对外共享、转让及公开披露行为，对此类数据的保存及处理将无需另行向您通知并征得您的同意。
                        </li>
                    </ul>
                </li>
            </ul>
        </div>
        <div>
            <h2>七、您如何管理您的个人信息</h2>
            <ul>
                <li>
                    您应确保提交的所有个人数据都准确无误，并及时更新这些数据。您可以通过以下方式访问及管理您的个人信息：
                    <ul>
                        <li>
                            <h3>（一）查询、更正您的个人信息</h3>
                            <ul>
                                <li>
                                    您有权访问您的个人信息，法律法规规定的例外情况除外。您可以通过以下方式自行访问或更正您的个人信息：
                                    <ul>
                                        <li>
                                            账户信息——如果您希望访问或编辑您的账户中的个人证件信息，手机绑定、支付信息、更改您的密码、添加安全信息或关闭您的账户等，您可以通过登录账号通过“设置”-“账号与安全”执行此类操作。
                                        </li>
                                        <li>
                                            个人资料—如果您希望访问或编辑您个人资料中的昵称、头像、兴趣爱好以及其他资料的，您可以通过登录账户通过“查看或编辑个人资料”执行此类操作。
                                        </li>
                                    </ul>
                                </li>
                            </ul>
                        </li>
                        <li>
                            <h3>（二）删除您的个人信息</h3>
                            <ul>
                                <li>
                                    您可以通过以下方式删除您的个人信息：
                                    <ul>
                                        <li>
                                            1、通过平台中提供的功能删除您的个人信息；
                                        </li>
                                        <li>
                                            2、您可以向我们提出删除个人信息的请求，尤其是出现以下情况时：
                                            <ul>
                                                <li>（1）如果我们处理个人信息的行为违反法律法规；</li>
                                                <li>（2）如果我们收集、使用您的个人信息，却未征得您的同意；</li>
                                                <li>（3）如果我们处理个人信息的行为违反了与您的约定；</li>
                                                <li>（4）如果您注销了平台账户；</li>
                                                <li>（5）如果我们终止服务及运营。</li>
                                            </ul>
                                        </li>
                                    </ul>
                                </li>
                                <li>
                                    <strong>
                                        如我们决定响应您的删除请求，我们还将同时通知从我们获得您的个人信息的实体，要求其及时删除，除非法律法规另有规定，或这些实体获得您的独立授权。当您从我们的服务中删除信息后，我们可能不会立即在备份系统中删除相应的信息，但会在备份更新时删除这些信息。
                                    </strong>
                                </li>
                            </ul>
                        </li>
                        <li>
                            <h3>
                                （三）注销账户
                            </h3>
                            <ul>
                                <li>
                                    您可以自行在“注销账户”页面（例如，平台手机APP“我-设置-账户与安全-注销账户”）提交账户注销申请。
                                </li>
                                <li>
                                    <strong>
                                        请您理解，您注销帐号的行为是不可逆的行为，一旦您注销您的帐号，平台将删除或匿名化有关您账户的信息。同时，您也无法通过已注销的账户获得平台的服务，如您注销账户再重新注册，原有账户信息也将无法恢复。
                                    </strong>
                                </li>
                            </ul>
                        </li>
                        <li>
                            <h3>（四）通过客服响应您的上述请求</h3>
                            <ul>
                                <li>
                                    在您无法自行通过账户密码进行操作的情况下，为保障个人信息安全，我们可能会先要求您验证自己的身份，然后再处理您的请求。您可能需要提供书面请求，或以其他方式证明您的身份。针对此类请求，我们将在15天内做出答复。
                                </li>
                            </ul>
                        </li>
                        <li>
                            <h3>（五）投诉举报</h3>
                            <ul>
                                <li>
                                    您可以按照我们公示的制度进行投诉或举报。如果您认为您的个人信息权利可能受到侵害，或者发现侵害个人信息权利的线索，您可以通过如下途径进行举报，我们核查后会在15个工作日内反馈您的投诉与举报：
                                    <ul>
                                        <li>
                                            1、通过微信公众号，点击在线客服与我们联系；
                                        </li>
                                        <li>2、通过邮件或客服电话与我们联系。</li>
                                    </ul>
                                </li>
                            </ul>
                        </li>
                        <li>
                            <h3>（六）在以下情形中，按照法律法规要求，我们将无法响应您的请求：</h3>
                            <ul>
                                <li>
                                    1、与国家安全、国防安全有关的；
                                </li>
                                <li>2、与公共安全、公共卫生、重大公共利益有关的；</li>
                                <li>3、与犯罪侦查、起诉、审判和执行判决等有关的；</li>
                                <li>4、响应您的请求将使其他个人、组织的合法权益受到严重损害的；</li>
                            </ul>
                        </li>
                    </ul>
                </li>
            </ul>
        </div>
        <div>
            <h2>八、未成年人的个人信息保护</h2>
            <ul>
                <li>（一）我们期望父母或监护人指导未成年人使用我们的服务若您是未满18周岁的未成年人，在使用我们的产品前，应在您的父母或其他监护人监护、指导下共同阅读并同意本政策。如果没有父母或监护人的同意，儿童（不满14周岁）不得创建自己的用户账号。</li>
                <li>（二）我们重视保护未成年人个人信息
                    <ul>
                        <li>我们根据国家相关法律法规的规定保护未成年人的个人信息，对于经父母同意而收集未成年人个人信息的情况，我们只会在受到法律允许、父母或监护人明确同意或者保护未成年人所必要的情况下使用、共享或公开披露此信息。</li>
                    </ul>
                </li>
                <li>（三）自查与接收反馈
                    <ul>
                        <li>如果我们发现自己在未事先获得可证实的父母同意的情况下收集了未成年人的个人信息，则会设法尽快删除相关数据。若您是未成年人的监护人，当您对您所监护的未成年人的个人信息有相关疑问时，请通过本政策公示的联系方式与我们联系。</li>
                    </ul>
                </li>
            </ul>
        </div>
        <div>
            <h2>九、本隐私政策如何更新</h2>
            <ul>
                <li>本隐私政策更新后，平台会在您登录及版本更新时以推送通知、弹窗的形式向您展示变更后的隐私政策，以便您及时了解本隐私政策的最新版本。<strong>如您继续使用我们的服务，表示同意接受修订后的本政策的内容，但是如果更新的内容需要采集视频、获取通讯录、联系方式、地理位置等个人敏感信息，仍会再次以显著方式征求您的同意。</strong></li>
                <li>对于重大变更，我们还会提供更为显著的通知（我们会通过包括但不限于短信、私信、在登录页面以弹窗做特别提示等方式，说明隐私政策的具体变更内容）。我们还会将本协议的旧版本存档，供您查阅。<strong>本隐私政策所指的重大变更包括但不限于</strong>
                    <ul>
                        <li><strong>1、我们的服务模式发生重大变化。如处理个人信息的目的、处理的个人信息的类型、个人信息的使用方式等；</strong></li>
                        <li><strong>2、个人信息共享、转让或公开披露的主要对象发生变化；</strong></li>
                        <li><strong>3、您参与个人信息处理方面的权利及其行使方式发生重大变化；</strong></li>
                        <li><strong>4、我们负责处理个人信息安全的责任部门、联络方式及投诉渠道发生变化时；</strong></li>
                        <li><strong>5、个人信息安全影响评估报告表明存在高风险时。</strong></li>
                    </ul>
                </li>
            </ul>
        </div>
        <div>
            <h2>十、争议管辖</h2>
            <ul>
                <li>本隐私政策的成立、生效、履行、解释及纠纷解决，适用中华人民共和国大陆地区法律。</li>
                <li>若您和我们发生任何纠纷或争议，首先应友好协商解决；协商不成的，您同意将纠纷或争议提交本隐私政策签订地<strong>（成都市）</strong>有管辖权的人民法院管辖。</li>
            </ul>
        </div>

        <div>
            <h2>十一、联系我们</h2>
            <ul>
                <li>公司名称：成都市艺苑网络科技有限公司</li>
                <li>注册地址：四川省成都市高新区神仙树西路3号1栋10层17号</li>
                <li>如果您对本隐私政策有任何疑问、意见或建议，您可以通过fbkf@tiange.com与我们联系</li>
            </ul>
        </div>
    </div>
</template>

<script>
export default {
   name: 'ServiceProvision',
   created() {
       document.title="隐私政策"
   }     
}
</script>

<style>
    body,ul,ol,li,p,h1,h2,h3,h4,h5,h6,form,label,dl,dt,dd,fieldset {margin:0;padding:0;}
    ul,ol,li {list-style:none;}
    .title{line-height:30px !important;margin-top:10px !important;color:#3f3f3f !important;font-size:18px !important;font-weight:700 !important; text-align: center;}
    table{border-collapse:collapse;border-spacing:0;}
    img {border:none;}
    input,img,select {vertical-align:middle;}
    body,fieldset,th,td,select,input,textarea {font-family:"微软雅黑",Arial,Helvetica,sans-serif; color:#666;}
    select,input {vertical-align:middle;}
    cite,em {font-style:normal;}
    .wordwrap {word-wrap:break-word;word-break:break-all;}

    a:link,a:visited,a:hover,a:active {text-decoration:none;}
    .text_box{ padding:20px;}
    .text_box div{ color:#000; line-height:24px;}
    .text_box h2{ font-size:16px;}
    h2{margin: 10px 0;}
</style>
